import axios from 'axios';

export function getRiskPredictorScore(model, VIN, referenceId, endDate, report, product, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const reference = referenceId || '';
  const url = `${config.getRiskPredictorScore}?model=${model}&VIN=${VIN}&referenceId=${reference}&endDate=${endDate}&report=${report}&product=${product}`;
  return dispatch => dispatch({
    type: 'RISK_PREDICTOR_SCORE_FETCH',
    payload: axios({ method: 'get', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}

export function clearRiskPredictorScore() {
  return {
    type: 'RISK_PREDICTOR_SCORE_CLEAR',
    payload: ''
  };
}



// WEBPACK FOOTER //
// ./src/actions/getRiskPredictorScore.js